import useSnackbar from '@/hooks/ui/use-snackbar.hook'
import SnackbarWrapper from '@/views/components/snackbar/snackbar.component'
import { PopoverConfirmComponent } from '@/views/components'

import usePopoverConfirm from '@/hooks/ui/use-popover-confirm.hook'

export const UiFeedbackWalletComponent = () => {
  const { snackbar, closeHandler } = useSnackbar({})
  const { popoverConfirm, handleClosePopoverConfirm } = usePopoverConfirm()

  return (
    <>
      <PopoverConfirmComponent
        {...popoverConfirm}
        handleClosePopoverConfirm={handleClosePopoverConfirm}
      />
      <SnackbarWrapper
        message={snackbar.message}
        open={snackbar.open}
        handleClose={closeHandler}
        variant={snackbar.variant}
        automaticClose
      />
    </>
  )
}
